<template>
  <div class="comment">
    <div class="seach">
      <el-row>
        <div class="seach-list r iblock">
          <el-select class="input-v" v-model="search.status" @change="seachStatus">
            <el-option
              v-for="(item,index) in options"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-input
            placeholder="请输入搜索内容"
            v-model="search.keywords"
            round
            class="input-with-select input-sea r"
          >
            <el-button slot="append" icon="el-icon-search" @click="seachList()"></el-button>
          </el-input>
        </div>
      </el-row>
    </div>
    <!-- //表格数据 -->
    <div class="list-wrap" v-if="resultData.list" v-loading="tableLoading">
      <el-table
        ref="table"
        stripe
        :data="resultData.list"
        :header-cell-style="{backgroundColor:'#f5f7fa'}"
        style="width: 100%;margin: 20px 0;"
      >
        <el-table-column label="头像/昵称">
          <template slot-scope="scope">
            <div class="user-info">
              <img class="guests-avatar" :src="scope.row.user_pfrofile_photo" alt />
              <span class="vm">{{scope.row.user_nick_name}}</span>
            </div>
          </template>
        </el-table-column>
          <el-table-column prop="comment_content" label="评论内容" min-width="100px"></el-table-column>
        <el-table-column prop="created_at" label="评论时间"></el-table-column>
        <el-table-column prop="course_name" label="资源名称"></el-table-column>
        <el-table-column prop="" label="类型">
          <template slot-scope="scope">
            <span v-show="scope.row.course_mode==1">语音直播</span>
            <span v-show="scope.row.course_mode==2">语音录播</span>
            <span v-show="scope.row.course_mode==3">视频直播</span>
            <span v-show="scope.row.course_mode==4">视频录播</span>
          </template>
        </el-table-column>
        <el-table-column prop="user_nick_name" label="回复"></el-table-column>
        <el-table-column prop="updated_at" label="回复时间"></el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <span v-show="scope.row.state==2">精选</span>
            <span v-show="scope.row.state==1">显示</span>
            <span v-show="scope.row.state==-1">隐藏</span>
            <span v-show="scope.row.state==-2">黑名单</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right">
          <template slot-scope="scope">
            <!-- <el-button type="text" size="mini" @click="respondMessage(scope.row,'1')">回复</el-button> -->
             <el-button type="text" size="mini" @click="privateMessage(scope.row,'1')">发私人消息</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="tc">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="Number(search.page)"
          :page-size="Number(search.size)"
          layout="total, prev, pager, next,jumper"
          :total="Number(resultData.count)"
        ></el-pagination>
      </div>
      <!-- 发送私人消息或者是全员消息的弹窗 -->
       <PrivateMessage
        :privateVisible.sync="privateVisible"
        :private_info="private_info"
        :messageType="messageType"
        @uploadStatus="uploadStatus"
      ></PrivateMessage>
        <!-- //回复评论和消息推送的弹窗 -->
      <RespondMessage :respondVisible.sync="respondVisible" :resmessage="resmessage" :titleType="titleType" @uploadInfo="uploadInfo"></RespondMessage>
    </div>
  </div>
</template>

<script>
//发送私人或者全员消息弹框
import PrivateMessage from "./components/private-message";

//引入回复评论和回复内容
import  RespondMessage from "./components/respond-message";
import qs from 'qs';

//引入混合mixins模式
import user_mixins from "./components/user-mixins";

import {_commentList,_addUserBlack,_commentReply} from '@/api/user.js'


export default {
  created() {
    this.initCommentsList()
  },
  mixins: [user_mixins],
  components:{
      RespondMessage,
      PrivateMessage
  },
  data() {
    return {
      tableLoading:false,
       search: {
        page:1,
        size:10,
        keywords:'',
        status:"0"
        // course_id:'',//课程id
        // state:'',//状态
        // comment_mode:'',//类型,1:讲解;2:讨论;3问答
      },
      options: [
        {
          label: "全部状态",
          value: "0"
        },
        {
          label: "精选",
          value: "2"
        },
        {
          label: "正常",
          value: "1"
        },
        {
          label: "隐藏",
          value: "-1"
        },
      ],
      resultData: {
       
      }
    };
  },
  methods: {
    //状态查询信息
    seachStatus(val) {
      this.chearSearchState();
      this.initCommentsList();
    },
    //查询信息
    seachList() {
      this.chearSearchState();
      this.initCommentsList();
    },
    //回复消息返回的状态
    uploadInfo(val){
      if(val){
        this.initCommentsList();
      }
    },
    // 发私人消息返回的状态
    uploadStatus(val){
      if(val){
        this.initCommentsList();
      }
    },
    //翻页
    handleCurrentChange(val) {
      this.search.page = val
      this.initCommentsList()
    },
     //加载列表
    initCommentsList(){
      this.tableLoading=true;
      _commentList({
        params:{
          page:this.search.page,
          size:10,
          keywords:this.search.keywords,
          state:this.search.status
        }
      }).then(res=>{
        this.tableLoading=false;
        if(res.resultCode==1){
          this.resultData=res.result;
        }else{
          tiis.$message.error(res.errorMsg);
        }
      })
    },
    addUserBlack(){
      return _addUserBlack;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.seach {
  .seach-list {
    .input-v {
      // width: 160px;
      margin-left: 20px;
    }
    .input-sea {
      margin-left: 20px;
      width: 280px;
      border-radius: 5px;
    }
  }
}
.user-info {
  .guests-avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    margin-right: 20px;
    vertical-align: middle;
  }
}
</style>